// extracted by mini-css-extract-plugin
export var desktopOnly = "desktop_only-module--desktopOnly--m7GiZ";